import { render, staticRenderFns } from "./Section6.vue?vue&type=template&id=0a77266a&scoped=true&"
import script from "./Section6.vue?vue&type=script&lang=js&"
export * from "./Section6.vue?vue&type=script&lang=js&"
import style0 from "./Section6.vue?vue&type=style&index=0&id=0a77266a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a77266a",
  null
  
)

export default component.exports